import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithDataV3 } from '../../services/CABE';
import '../../css/dashboard.css'
import LoadingWindow from '../../components/LoadingWindow';
import { AiOutlineReload, AiOutlineDollarCircle } from "react-icons/ai";
import { Menu } from "../../components/Menu/Menu";

function formatDateInput(date) {
    return date.toISOString().slice(0, 10)
}
function addDays(date, days) {
    const d = new Date(date)
    d.setDate(d.getDate() + days)
    return d
}

/**
 * CommissionsV3 — new report (2026-08-18), not a clone of any v2 page.
 * Distinct from the existing SalesCommissionReport.js (v2, untouched — that
 * one calculates $ commission from revenue/cash receipts). This report
 * answers a different, narrower question the client asked for: "cuantas SO
 * se hicieron invoices" per salesperson, using document_audit_trail's
 * salespersonNo (captured at SO creation, immune to the later-edit-overwrite
 * bug) instead of the mutable sales_orders_aws_v2.salesperson_no column.
 *
 * Only counts Sales-Order-side events until Invoices V3 exists and starts
 * writing 'converted_to_invoice' rows (see memory
 * project_invoices_v3_pending.md) — convertedCount will read 0 for everyone
 * until then, which is why the disclaimer banner below is not optional.
 */
export default class CommissionsV3 extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        dateStart: formatDateInput(addDays(new Date(), -30)),
        dateEnd: formatDateInput(new Date()),
        salespersonNo: '',
        idCompany: getValueCookie('CompanyId') || '',
        rows: [],
        loaded: false,
        loadError: '',
    }

    onChangeField = (field, value) => {
        this.setState({ [field]: value })
    }

    async loadData() {
        this.ModalLoading.current.showState(true)
        this.setState({ loadError: '' })
        try {
            const resp = await getInformationWithDataV3('/v3/audit/commissions', {
                idCompany: Number(this.state.idCompany),
                dateStart: this.state.dateStart,
                dateEnd: this.state.dateEnd,
                salespersonNo: this.state.salespersonNo || undefined,
            })
            if (resp && resp.status && resp.status.code === 1) {
                this.setState({ rows: resp.data || [], loaded: true })
            } else {
                this.setState({ rows: [], loaded: true, loadError: 'Could not load commissions data.' })
            }
        } catch (error) {
            console.error('CommissionsV3 loadData failed:', error)
            this.setState({ rows: [], loaded: true, loadError: 'Could not load commissions data — the server did not respond.' })
        } finally {
            this.ModalLoading.current.showState(false)
        }
    }

    render() {
        const { rows, loaded } = this.state
        const totalSO = rows.reduce((sum, r) => sum + Number(r.soCount || 0), 0)
        const totalConverted = rows.reduce((sum, r) => sum + Number(r.convertedCount || 0), 0)

        return (
            <div className="dash-page pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                            <AiOutlineDollarCircle style={{ color: 'white', fontSize: '1.75rem' }} />
                        </div>
                        <div>
                            <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Commissions (V3)</h1>
                            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Sales Orders created vs. converted to Invoice, by salesperson</p>
                        </div>
                    </div>
                </div>

                <div className="container-fluid" style={{ marginTop: 24 }}>
                    {this.state.loadError && (
                        <div className="metric-card status-danger mb-3">
                            <div style={{ color: '#DC2626', fontSize: '0.85rem' }}>{this.state.loadError}</div>
                        </div>
                    )}

                    <div className="metric-card status-warning mb-4">
                        <div style={{ color: '#92400E', fontSize: '0.85rem' }}>
                            Invoices V3 doesn't exist yet, so <strong>Converted to Invoice</strong> will show 0 for every salesperson until it does.
                            This report already tracks Sales-Order-side data correctly, and will pick up invoice conversions automatically once that page is built — no changes needed here.
                        </div>
                    </div>

                    <div className="row g-3 mb-4 align-items-end">
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>From</label>
                            <input type="date" value={this.state.dateStart} onChange={(e) => this.onChangeField('dateStart', e.target.value)}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem' }} />
                        </div>
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>To</label>
                            <input type="date" value={this.state.dateEnd} onChange={(e) => this.onChangeField('dateEnd', e.target.value)}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem' }} />
                        </div>
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>Salesperson No. (optional)</label>
                            <input type="text" placeholder="e.g. JC" value={this.state.salespersonNo}
                                onChange={(e) => this.onChangeField('salespersonNo', e.target.value.toUpperCase())}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem', width: '160px' }} />
                        </div>
                        <div className="col-auto">
                            <button
                                onClick={() => this.loadData()}
                                type="button"
                                style={{
                                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                    border: 'none', borderRadius: '10px', color: 'white', padding: '0.7rem 1.5rem',
                                    fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', display: 'flex',
                                    alignItems: 'center', gap: '0.5rem',
                                }}
                            >
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                    </div>

                    {loaded && rows.length > 0 && (
                        <>
                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <div className="metric-card status-primary">
                                        <div className="metric-label">Salespeople with activity</div>
                                        <div className="metric-value">{rows.length}</div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="metric-card status-success">
                                        <div className="metric-label">Total Sales Orders created</div>
                                        <div className="metric-value">{totalSO}</div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="metric-card status-warning">
                                        <div className="metric-label">Total converted to Invoice</div>
                                        <div className="metric-value">{totalConverted}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="tableFixHeadSmall">
                                <table className="table table-clean align-middle">
                                    <thead>
                                        <tr>
                                            <th>Salesperson No.</th>
                                            <th className="text-end">Sales Orders Created</th>
                                            <th className="text-end">Converted to Invoice</th>
                                            <th className="text-center">Conversion Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, i) => {
                                            const so = Number(row.soCount || 0)
                                            const conv = Number(row.convertedCount || 0)
                                            const rate = so > 0 ? (conv / so) * 100 : 0
                                            return (
                                                <tr key={i}>
                                                    <td>{row.salespersonNo || '(unassigned)'}</td>
                                                    <td className="text-end">{so}</td>
                                                    <td className="text-end">{conv}</td>
                                                    <td className="text-center">
                                                        <span style={{
                                                            display: 'inline-block', padding: '2px 10px', borderRadius: '999px',
                                                            fontSize: '0.78rem', fontWeight: 600,
                                                            background: rate >= 80 ? 'rgba(16,185,129,0.1)' : rate > 0 ? 'rgba(245,158,11,0.1)' : 'rgba(100,116,139,0.08)',
                                                            color: rate >= 80 ? '#059669' : rate > 0 ? '#D97706' : '#64748B',
                                                        }}>{rate.toFixed(1)}%</span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                    {loaded && rows.length === 0 && !this.state.loadError && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineDollarCircle style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>No Sales Orders found in this date range.</p>
                        </div>
                    )}

                    {!loaded && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineReload style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>Click <strong style={{ color: '#1e3a8a' }}>Load Data</strong> to see commission counts.</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
